import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { MatAutocompleteSelectedEvent, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { HotelService } from 'src/app/services/hotel.service';
import { DataService } from 'src/app/services/data.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SettingsService } from '../../services/settings.service';
import { CarrierCodeService } from '../../services/carrier-code.service';
// import * as HotelLef from 'leaflet';

import { DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialogConfig } from '@angular/material/dialog';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { Pipe, PipeTransform } from '@angular/core';
import { AirConfigService } from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { MatTabGroup } from '@angular/material/tabs';
declare let google: any;

@Component({
  selector: 'app-hotel-list',
  templateUrl: './hotel-list.component.html',
  styleUrls: ['./hotel-list.component.css']
})
export class HotelListComponent {
  allData: any
  showDetails: boolean = false



  airlines: any
  stop: any
  filterTime: any
  CancellationTab: boolean = false
  minData = new Date()
  fairRbookingDetail: any
  carrierCode: any = []
  fairbookingDetail: any
  uniqueNumbers: any
  uniqueFlightName: any
  sharePopup: boolean = false
  messageResult: any
  currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 0;
  selectedItem: string = 'Economy';
  selectedPerson: string = 'Adult'
  adult: any;
  child: any;
  Infants: any;
  journeyType = "oneWay";
  separatorKeysCodes: number[] = [ENTER, COMMA];
  separatorKeysCodesTo: number[] = [ENTER, COMMA];
  announcer = inject(LiveAnnouncer);


  showOneWay: boolean = false
  showReturn: boolean = false
  showMulti: boolean = false
  ToCtrl = new FormControl('');
  wherecity: any;

  dynamicTooltip: any = ""
  searchFg!: FormGroup
  dates: Date[] = [];
  selectedDate: Date | null = null;
  currentDate: Date = new Date();
  messageData: any;
  departureFlight: any
  returnFlight: any
  showPending: boolean = false
  hotelList: any = []
  flightDetail: any
  returnFlightDetail: any
  flightDetails: boolean = true
  flightDataList: any
  userType: any
  viewData: boolean = false
  allEmailData: any = []
  SelectedEmailData: any = []
  SelectedInboundEmail: any = []
  SelectedInboundEmailData: any = []
  userUuid: any
  allInboundEmailData: any = []
  SelectedView: boolean = false
  domIn: any = {
    international: false,
    domestic: false
  }
  osm: any
  map: any
  markers: L.Marker[] = [];

  loginUserType:any=''
  constructor(private UserprofileService: UserprofileService, private SettingsService: SettingsService, private toastMsgService: ToastmsgService, private fb: FormBuilder, private hotelService: HotelService, private route: ActivatedRoute
    , private router: Router, private data: DataService, private CarrierCodeService: CarrierCodeService, private AirConfigService: AirConfigService, private userInfoService: UserInfoService,) {

    this.userType = this.userInfoService.getUserType()
    this.userType = this.userType.toUpperCase()
    this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
    this.userUuid = this.userInfoService.getUserUuid()



    this.carrierCode = this.CarrierCodeService.carrierCode()
    // this.imageData()
    this.getCorporateUsers()
    // this.getFlightList()
    this.route.queryParams.subscribe(params => {
      let data: any
      data = params

    });
    this.data.portMessage.subscribe((message: any) => this.messageData = message)

    console.log()
    this.data.deliverMsg(this.messageData)

    // console.log('jhjh')
    if (this.messageData.journeyType) {
      // console.log('jhjh')

      this.journeyType = this.messageData.journeyType
    }

    if (this.messageData === "default message") {

      this.router.navigate(["/app/hotel"]);
    } else {


      this.searchHotel()
     
    }

    // this.dataFields()
    // this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
    //   debounceTime(300), // Adjust the debounce time as needed
    //   distinctUntilChanged(),
    //   startWith(null),
    //   map((airport: any | null) => (airport ? this._filter(airport) : this.allFruits.slice())),
    // );
    // this.filteredTo = this.ToCtrl.valueChanges.pipe(
    //   debounceTime(300), // Adjust the debounce time as needed
    //   distinctUntilChanged(),
    //   startWith(null),
    //   map((airports: any | null) => (airports ? this._filterTo(airports) : this.whereTo.slice())),
    // );

    //this.ToInput.nativeElement.value='DEL'
    // this.searchFg=this.fb.group({
    //       "fromAirport" :  ['',[Validators.required]],
    //       "toAirport" : ['',[Validators.required]],
    //       "requestedDate":[ this.messageData.airSearchRequestBaseDetails[0].requestedDate],
    //       "requestedClass":[''],
    //       "paxCount":[0],
    //       "adultCount":[0],
    //       "childCount":[0],
    //       "infantCount":[0],
    //       "returnDate":[this.messageData?.airSearchRequestBaseDetails[1]?.requestedDate],
    //       "menu":[this.journeyType]
    //     });
  }

  ngOnInit(): void {
    this.populateDates();
    this.selectedDate = this.currentDate;
   

  }
  step: number = 1;

  setStep(index: number): void {
    this.step = index;
  }
  selectDate(date: Date) {
    this.selectedDate = date;
  }

  populateDates() {
    this.dates = [];
    const weekStartDate = new Date(this.currentDate);
    weekStartDate.setDate(weekStartDate.getDate() - weekStartDate.getDay()); // Start of the current week
    for (let i = 0; i < 7; i++) {
      this.dates.push(new Date(weekStartDate));
      weekStartDate.setDate(weekStartDate.getDate() + 1); // Move to the next day
    }
  }

  navigateWeek(offset: number) {
    const newDate = new Date(this.currentDate);
    newDate.setDate(newDate.getDate() + offset * 7); // Move to the next or previous week
    this.currentDate = newDate;
    this.populateDates();
    this.selectedDate = this.currentDate;
  }
  starNumbers: any
  next: any
  mealsList: any = []
  searchHotel() {
this.searchQuery=''
    let maps: any
    this.map = maps
    // this.messageData.city="Delhi"
    this.messageData.pageNo = 0
    this.hotel=null
    this.hotelList = null
    this.allData = null
    this.endIndex = 10;  // Start by showing the first 10 items
    this.increment = 10;
    this.visibleHotels = []
    let markers: L.Marker[] = [];
    this.markers = markers
    //  https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png
    //https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
    // https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}
    let mapKey = 'AIzaSyD4ZT_HzOrdyHl1cKO0eCc0bQsIBh4ROls'
    // https://maps.googleapis.com/maps/api/js?key='+mapKey+'&loading=async&libraries=maps,marker&v=beta
    // this.osm = HotelLef.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    // });
    this.showDetails = false

    this.showPending = true

    setTimeout(() => {
      this.showPending = false

    }, 20 * 60 * 1000);
    this.hotelList = null
    let request = JSON.parse(JSON.stringify(this.messageData))
    //  delete request.uuid;

    this.hotelService.SearchHotel(request)

      .subscribe({
        
        next: (res) => {
          
          // debounceTime(1), // Adjust the debounce time as needed
          // distinctUntilChanged(),
          this.showPending = false

          if (res) {
            if (res) {
              if (res[0].hotels.lenght != 0) {
                let data: any
                data = res
                this.allData = res[0]?.hotels
  
              this.fetchHotelName(this.allData)
              this.fetchSourceName(this.allData)
                this.next = res?.next
                this.messageData.pageNo = Number(this.next)

                const uniqueNumbers = new Set<number>();
                let commonNumbers: number[] = [];

                //  if ( this.map) {
                //   this.map?.remove();
                //   this.map = null;
                // }
                this.initializeMap()
                //  const bounds = new google.maps.LatLngBounds();

                this.allData.forEach((item: any, index: number) => {
                  // if(index===0){
                  // this.map = new google.maps.Map(document.getElementById('map'), {
                  //   center: { lat: item.location.geo.lat, lng: item.location.geo.lon },
                  //   zoom: 15
                  // });

                  // const marker = new google.maps.Marker({
                  //   position: { lat: item.location.geo.lat, lng: item.location.geo.lon },
                  //   map: this.map
                  // });
                  // const popupContent = `<span style="color:blue"><b>${item.name}</b></span><br>
                  //   <b>${item.location.baseCityName} | ${item.location.state} | ${item.location.countryName}</b>
                  // `;


                  // const infoWindow = new google.maps.InfoWindow({
                  //   content: popupContent
                  // });

                  // marker.addListener('mouseover', () => {
                  //   infoWindow.open(map, marker);
                  // });

                  // marker.addListener('mouseout', () => {
                  //   infoWindow.close();
                  // });


                  // var service = new google.maps.places.PlacesService(map);

                  // // Specify the location and radius for the search
                  // var request = {
                  //   location: { lat: item.location.geo.lat, lng: item.location.geo.lat },
                  //   radius: '500' // Adjust the radius as needed (in meters)
                  // };


                  // service.nearbySearch(request, function(results:any, status:any) {
                  //   if (status === google.maps.places.PlacesServiceStatus.OK) {
                  //     for (var i = 0; i < results.length; i++) {
                  //       var place = results[i];
                  //       // Fetch detailed information about each place
                  //       service.getDetails({ placeId: place.place_id }, function(placeDetails:any, status:any) {
                  //         if (status === google.maps.places.PlacesServiceStatus.OK) {
                  //           console.log('Place details:', placeDetails);
                  //           // Here you can access reviews, ratings, and other details
                  //           console.log('Reviews:', placeDetails.reviews);
                  //           console.log('Rating:', placeDetails.rating);
                  //           // Add more code to display these details on your map or page
                  //         }
                  //       });
                  //     }
                  //   }
                  // });
                  // Add an event listener for the mouseover event
                  // marker.addListener('mouseover', () => {
                  //   const infoWindow = new google.maps.InfoWindow({
                  //     content: popupContent
                  //   });
                  //   infoWindow.open(map, marker);
                  // });

                  // // Optionally, add an event listener for mouseout to close the popup
                  // marker.addListener('mouseout', () => {
                  //   const infoWindow = new google.maps.InfoWindow();
                  //   infoWindow.close();
                  // });








                  // this.ngOnDestroy()
                  // setTimeout(() => {

                  // this.initMarkers(item);}, 100)
                  if (uniqueNumbers.has(item.starRating)) {
                    // If the number is already in the set, it's a common number
                    commonNumbers.push(item.starRating);
                  } else {
                    // Otherwise, add it to the set
                    uniqueNumbers.add(item.starRating);
                  }


                  this.starNumbers = new Set([...uniqueNumbers])
                  this.starNumbers = Array.from(this.starNumbers)
                  this.starNumbers = this.starNumbers.filter((star:any) => star !== null && star !== undefined);


                  if (item.rooms[0].rate.description) {
                    this.mealsList = this.commonMeals(item.rooms[0].rate.description)
                    // console.log(this.mealsList)
                  }
                  item.slideIndex = 1;

                  let slidImg: any = []
                  // item.media.hotel[0].images.forEach((items:any)=>{

                  item?.media?.forEach((items: any) => {

                    // let itm={url:items.replace('//', 'https://')}
                    // let itm = { url: items }
                    let itm = { url: items };
                    if (itm.url && !(itm.url.startsWith("https://") || itm.url.startsWith("http://"))) {
                      itm.url = itm.url.replace('//', 'https://');
                    };
                    // console.log(itm)
                    //if(itm.url) itm.url=itm.url.replace("http://","https://")
                    slidImg.push(itm);
                    // console.log(itm)
                  })
                  item.slides = slidImg

                  // { img: '../../../assets/images/swimming-pool-beach-luxury-hotel-type-entertainment-complex-amara-dolce-vita-luxury-hotel-resort-tekirova-kemer-turkey.jpg', caption: 'Caption Two', id: 1 },




                  //             item.slides = [
                  //               { img: '../../../assets/images/swimming-pool-beach-luxury-hotel-type-entertainment-complex-amara-dolce-vita-luxury-hotel-resort-tekirova-kemer-turkey.jpg', caption: 'Caption Two', id: 1 },
                  //   { img: '../../../assets/images/hotelroom2.avif', caption: 'Caption Text', id: 2 },
                  //   {img: '../../../assets/images/frames-for-your-heart-zSG-kd-L6vw-unsplash.jpg', caption: 'Caption three', id: 3}

                  // ];

                  this.showSlides(item.slideIndex, item);
                  // const position = new google.maps.LatLng(item.location.geo.lat, item.location.geo.lon);
                  //             bounds.extend(position);
                })


                // Add markers to the bounds


                // Adjust the map to fit all markers
                // map.fitBounds(bounds);
                // console.log(this.allData[0].rooms[0].rate.inclusive)

                // this.allData=this.allData.sort((a:any, b:any) => {
                //   const priceA = a.rooms[0]?.rate.reduce((acc:any, curr:any) => acc + curr.inclusive, 0);
                //   const priceB = b.rooms[0]?.rate.reduce((acc:any, curr:any) => acc + curr.inclusive, 0);
                //   return priceA - priceB;
                // });
                this.hotelList = this.allData
                this.endIndex = 10;
                this.increment = 10;
                this.loadMoreHotels()



                // this.hotelList.sort((a:any, b:any) => {
                //   return  a.rooms[0]?.ratePlans[0]?.price?.basePrice
                // });

                this.calculateMinMaxPrices()
              }
              else {
                this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });

              }
            }
            else {
              this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });

            }

          } else {
            // this.router.navigate(["/app/flight"]);
            this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });


          }

          setTimeout(() => {
            // this.getPlaceAutocomplete();
          }, 1000);
        }, error: (err) => {

          this.showPending = false

          //this.router.navigate(["/app/flight"]);
          this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });

        }
      }
      )
  }
hotelName:any=[]
hotel:any
sourceName:any=[]

fetchSourceName(items:any){
  function fetchCommonAndUniqueNames(data: { source: string }[]) {
    const nameCount: { [key: string]: number } = {};
    
    // Count occurrences of each name
    data.forEach(item => {
      nameCount[item.source] = (nameCount[item.source] || 0) + 1;
    });
  
    const commonNames: string[] = [];
    const uniqueNames: string[] = [];
  
    // Segregate names based on their count
    for (const name in nameCount) {
      if (nameCount[name] > 0) {
        commonNames.push(`${name}(${nameCount[name]})`);
        
      } else {
        uniqueNames.push(name);
      }
    }
  
    return { commonNames, uniqueNames };
  }
  
  const result = fetchCommonAndUniqueNames(items);
  this.sourceName=result.commonNames
  
}
  fetchHotelName(items:any){
    function fetchCommonAndUniqueNames(data: { name: string }[]) {
      const nameCount: { [key: string]: number } = {};
      
      // Count occurrences of each name
      data.forEach(item => {
        nameCount[item.name] = (nameCount[item.name] || 0) + 1;
      });
    
      const commonNames: string[] = [];
      const uniqueNames: string[] = [];
    
      // Segregate names based on their count
      for (const name in nameCount) {
        if (nameCount[name] > 0) {
          commonNames.push(name);
        } else {
          uniqueNames.push(name);
        }
      }
    
      return { commonNames, uniqueNames };
    }
    

    const result = fetchCommonAndUniqueNames(items);
    this.hotelName=result.commonNames
    // console.log('Common Names:', result.commonNames);
    // console.log('Unique Names:', result.uniqueNames);
    this.filteredNames = [...this.hotelName]; // Initially show all names



   

  }
  
  searchQuery: string = '';
  filteredNames: string[] = [];
  // Extract common names

  // Filter names based on search query
  filterNames(){
    console.log(this.searchQuery.toLowerCase().trim())
    this.filteredNames = this.hotelName.filter((name:any) =>
  
      name.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())
    );
  }
  

  converter(item: any) {
    const totalMinutes = item;
    const hours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    item = `${hours}h ${remainingMinutes}m`
    return item
  }

  convertInTime(item: any) {

    const hours = Math.floor(item / 100);
    const minutes = item % 100;
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${ampm}`;



    item = formattedTime;
    return item
  }
  formatTimeComponent(component: number): string {
    return component < 10 ? `0${component}` : component.toString();
  }







  openReturnPopup() {
    this.flightDetails = false




  }
  onClickRFare(fare: any, item: any, items: any) {
    this.step = 1

    //console.log(item)
    items.selected = true

    for (let flight of this.returnFlightDetail) {
      flight.selected = false
      for (let i = 0; i < flight.fare.length; i++) {
        flight.fare[i].selected = ''

      }
    }
    items.selected = true

    for (let i = 0; i < item.length; i++) {

      item[i].selected = ''

    }
    fare.selected = 'true'


    this.fairRbookingDetail = fare
    this.returnFlight.fare = [this.fairRbookingDetail]
  }


  dateFormate(date: any) {
    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-US');
    date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    return date

  }

  cityFilter(item: any) {
    // console.log(item)
    if (item && this.flightDataList) {


      item = this.flightDataList.filter((itm: { iataCode: any; }) => itm.iataCode === item)
      // console.log(item)

      item = item[0]?.city

      return item
    } else {
      return item
    }
  }
  airPortFilter(item: any) {

    if (item && this.flightDataList) {

      item = this.flightDataList.filter((itm: { iataCode: any; }) => itm.iataCode === item)

      item = item[0]?.name
      return item
    } else {
      return item
    }
  }
  fligthNameFilter(item: any) {

    if (item) {
      let flightName: any = []
      flightName = this.carrierCode.filter((itm: { carrierCode: any; }) => itm.carrierCode === item)

      if (flightName.length === 0) {
        return item

      } else {
        flightName = flightName[0]?.flightName
        return flightName
      }
    } else { return item }
  }
  flightlogoFilter(item: any) {

    if (item) {
      let flightName: any = []
      flightName = this.carrierCode.filter((itm: { carrierCode: any; }) => itm.carrierCode === item)

      if (flightName.length === 0) {
        return item

      } else {
        flightName = flightName[0]?.logo
        return flightName
      }
    } else { return item }
  }
  ActiveDeparture: any
  ActiveReturn: any
  selectFlight(item: any) {
    item.selected = true
    if (item == this.ActiveDeparture) {

    } else {

      this.ActiveDeparture = item
      this.departureFlight = { ...item }
      this.departureFlight.fare = [{ ...item.fare[0] }]

    }
  }
  selectRFlight(item: any) {
    if (item == this.ActiveReturn) {


      //this.returnFlight.fare=this.returnFlight.fare[0]

    } else {
      this.ActiveReturn = item
      this.returnFlight = { ...item }
      this.returnFlight.fare = [{ ...item.fare[0] }]

    }
  }
  activeDeparture(item: any) {
    if (item == this.ActiveDeparture) {

      return item
    }
  }
  activeReturn(item: any) {
    if (item == this.ActiveReturn) {
      return item
    }
  }
  openPopup(item: any, fare: any) {

    let flight: any
    flight = { ...item }

    this.departureFlight = flight
    this.departureFlight.fare = [fare]
    this.flightDetails = false;
  }
  closePopup() {
    this.sharePopup = false
    this.flightDetails = true;

    this.allEmailData = []
    this.allInboundEmailData = []
  }







  Tooltip(item: string) {
    item = "hello"
  }


  selectItem(item: string) {
    this.selectedItem = item;
  }
  selectPerson(item: string) {
    this.selectedPerson = item;
  }
  selectedDetail: boolean = false

  SelectDetail() {
    this.selectedDetail = !this.selectedDetail

  }

  onArrowClick(item: any) {
    item = true
    // console.log(item)
  }




  passengerTypeMapping(item: any) {
    let type: any = []

    if (item) {


      const typePassenger = item
      if (typePassenger) {
        type = typePassenger.filter((typeItem: any) => typeItem.fareDetailsPerPassengerType.passengerType === "ADT")
      }
      //console.log(type)
      return type
    } else {
      return []

    }


  }
  passengerCTypeMapping(item: any) {

    let type: any = []

    if (item) {


      const typePassenger = item
      if (typePassenger) {
        type = typePassenger.filter((typeItem: any) => typeItem.fareDetailsPerPassengerType.passengerType === "CH" || typeItem.fareDetailsPerPassengerType.passengerType === "CHD" || typeItem.fareDetailsPerPassengerType.passengerType === "CNN")
      }
      //console.log(type)
      return type
    } else {
      return []

    }


  }
  passengerITypeMapping(item: any) {

    let type: any = []

    if (item) {


      const typePassenger = item
      if (typePassenger) {
        type = typePassenger.filter((typeItem: any) => typeItem.fareDetailsPerPassengerType.passengerType === "INF" || typeItem.fareDetailsPerPassengerType.passengerType === "IN")
      }
      //console.log(type)
      return type
    } else {
      return []

    }


  }
  fareMapping(fare: any, item: any, fareiItem: any) {
    if (fare?.fareType == item.fare[1]?.fareType) {
      let type: any[] = [];

      if (item?.flightDetailsList) {
        for (let i = 0; i < item.flightDetailsList.length; i++) {
          const bookingClasses = item.flightDetailsList[i]?.bookingClasses;

          if (bookingClasses) {
            type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareType === fare?.fareType);
          }
        }
      }
      return type
      // You might want to return something here based on your requirements
      // return type?.fareDetailsPerPassengerType?.taxes;
    } else {
      return []
      // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
      // return '';
    }
  }
  fareOMapping(fare: any, item: any, fareiItem: any) {
    if (fare?.fareType == fare?.fareType) {
      let type: any[] = [];

      if (item?.flightDetailsList) {
        for (let i = 0; i < item.flightDetailsList.length; i++) {
          const bookingClasses = item.flightDetailsList[i]?.bookingClasses;

          if (bookingClasses) {
            type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareType === fare?.fareType);
          }
        }
      }
      return type
      // You might want to return something here based on your requirements
      // return type?.fareDetailsPerPassengerType?.taxes;
    } else {
      return []
      // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
      // return '';
    }
  }

  fareTypeMapping(item: any) {
    if (item?.fare && item.fare[0]?.fareType) {
      let type: any[] = [];

      if (item?.flightDetailsList) {
        for (let i = 0; i < item.flightDetailsList.length; i++) {
          const bookingClasses = item.flightDetailsList[i]?.bookingClasses;

          if (bookingClasses) {
            type = bookingClasses.filter((bookingItem: any) => bookingItem?.fareType === item.fare[0]?.fareType);
          }
        }
      }
      return type
      // You might want to return something here based on your requirements
      // return type?.fareDetailsPerPassengerType?.taxes;
    } else {
      return []
      // Handle the case where item?.fare or item?.fare[0]?.fareType is not defined
      // return '';
    }
  }

  getObjectKeysAndValues(obj: any): { key: string, value: any }[] {
    // console.log(this.departureFlight)
    // let flight:any=this.departureFlight


    if (obj) {

      let object: any = []
      object = Object.entries(obj).map(([key, value]) => ({ key, value }));
      for (let i = 0; i < object.length; i++) {
        //console.log(object[i].value)

        object[i].value = (object[i]?.value?.join(','))


      }
      return object;
    } else {
      return obj
    }
  }
  areDatesEqual(date1: Date, date2: Date): boolean {
    // Compare year, month, and day to check if the dates are equal
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }





  getObjectKeysAndValue(obj: any): { key: string, value: any }[] {
    // console.log(this.departureFlight)
    // let flight:any=this.departureFlight

    if (obj) {


      let object: any = []
      object = Object.entries(obj).map(([key, value]) => ({ key, value }));
      //    let hiddenKeys: any="bookingAmount,currency"
      // object=object.filter((item:any)=>!hiddenKeys.includes(item.key))


      return object;
    } else {
      return obj
    }
  }

  showDialog: boolean = false
  showAirDialog: boolean = false
  showTimeDialog: boolean = false
  OpenDialog() {
    this.showDialog = true
  }

  closeDialog() {
    this.showDialog = false
    this.showAirDialog = false
    this.showTimeDialog = false
  }
  OpenAirDialog() {
    this.showAirDialog = true
  }
  OpenTimeDialog() {
    this.showTimeDialog = true


  }
  sortStars(item: any) {
    if (item) {
      item.sort();
      return item

    } else {
      return []
    }


  }
  sortByAsc: boolean = true
  sortByPrice(): void {
    if (this.sortByAsc) {
      this.hotelList.sort((a: any, b: any) => a.rooms[0]?.rate?.totalAmount - b.rooms[0]?.rate?.totalAmount);
    } else if (!this.sortByAsc) {
      this.hotelList.sort((a: any, b: any) => b.rooms[0]?.rate?.totalAmount - a.rooms[0]?.rate?.totalAmount);
    }




    this.sortByAsc = !this.sortByAsc;
    this.endIndex = 10;
    this.increment = 10;
    this.loadMoreHotels();

  }
  // <button (click)="sortByPrice()">Sort by Price</button>
  // <input type="number" placeholder="Enter min base fare" [(ngModel)]="minBaseFare">
  // <button (click)="filterByBaseFare(minBaseFare)">Filter by Base Fare</button>
  minBaseFare: any
  filterByBaseFare(): void {
    this.hotelList = this.allData.filter((hotel: any) => hotel.rooms[0]?.ratePlans?.some((h: any) => h.price.basePrice + h.price.totalTax >= this.value));
  }

  minPrice: any
  maxPrice: any
  value: any
  calculateMinMaxPrices(): void {

    let prices: any = []
    this.hotelList.forEach((hotel: any) =>
      prices.push(hotel.rooms[0]?.rate?.totalAmount)

    );

    this.minPrice = Math.min(...prices);
    this.maxPrice = Math.max(...prices);

    // console.log(this.minPrice)
    // console.log(this.maxPrice)

  }


  starFilter() {

    if (this.filterTime.length === 0) {
      this.hotelList = this.allData
    } else {
      this.hotelList = this.allData.filter((hotel: any) => this.filterTime.includes(hotel.starRating))

    }
    // console.log(this.hotelList)
  }
  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }

  onMenuClick(event: any) {
    event.preventDefault();
    event.stopPropagation();


  }















  getCorporateUsers() {

    this.UserprofileService
      .getUserList()
      .subscribe({
        next: (res: any) => {
          if (res) {

            let data: any
            data = res


            // console.log(this.usersList)

          } else {
          }
        }, error: (err) => {


        }
      }
      )
  }






  getEmployeeData() {

    this.UserprofileService
      .getEmployeeUser()
      .subscribe({
        next: (res: any) => {
          if (res) {

            let data: any
            data = res




          } else {

          }
        }, error: (err) => {


        }
      }

      )

  }












  // slideIndex = 1;
  // slides = [
  //   { img: '../../../assets/images/hotelroom2.avif', caption: 'Caption Text', id: 1 },
  //   { img: '../../../assets/images/hotelRoom.avif', caption: 'Caption Two', id: 2 },
  //   {img: '../../../assets/images/frames-for-your-heart-zSG-kd-L6vw-unsplash.jpg', caption: 'Caption three', id: 3}

  // ];


  plusSlides(n: number, item: any): void {
    this.showSlides(item.slideIndex += n, item);

  }

  currentSlide(n: number, item: any): void {
    this.showSlides(item.slideIndex = n, item);
  }

  private showSlides(n: number, item: any): void {
    if (n > item.slides.length) { item.slideIndex = 1 }
    if (n < 1) { item.slideIndex = item.slides.length }
    // Normally, Angular handles showing and hiding via structural directives, so you might not need this part.
  }
  filters: boolean = false
  moreFilters() {
    this.filters = !this.filters

  }
  onClickDetails(item: any, pointer: any) {
    // console.log(this.messageData)

    let packageRate:any=''
    if(item?.rooms[0]?.rate?.packageRate===true){
      packageRate='HP'
    }else{
      packageRate='HO'
    }
    
    let Request:any={...this.messageData}
    Request.rateType=packageRate
    
    let data: any = {
      items: {
        'id': item?.id
      },
      'name': item?.name,
      'searchDetail': Request,
      'scrollData': pointer
    }

    let url = "/app/hotel-detail/" + this.SettingsService.transform(JSON.stringify(data))

    window.open(url);

    // var myWindow:any = window.open("/app/hotel-detail", "", "width=1400px, height=500");
    // myWindow.blur();
  }

  backClick() {
    let markers: L.Marker[] = [];
    this.markers = markers
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    // this.initializeMap()
    // this.allData.forEach((item:any)=>{

    //   setTimeout(() => {

    //     this.initMarkers(item);}, 100)

    // })
    this.hotelList = this.allData
    this.showDetails = false

  }
  lengthFixed(item: any) {
    let items: any = []
    if (item) {
      if (item[0]) {
        items[0] = item[0]
      }
      if (item[1]) {

        items[1] = item[1]
      }

      return items
    } else {
      return []
    }
  }

  starArray(item: any) {
    // console.log(item)

    let star = []
    if (item) {
      // console.log(item)
      for (let i = 0; i < item; i++) {
        star.push(i + 1)
      }
    }

    // console.log(star)
    return star
  }




  ngOnDestroy() {
    if (this.map) {
      this.map.remove();
    }
  }
  initializeMap() {


    //   setTimeout(() => {
    //   this.map = HotelLef.map('mapMain', {
    //     // center: [28.5943549, 77.3321085],
    //     zoom: 17,
    //     layers: [this.osm],
    //     attributionControl:false
    //   })

    // // this.getChargerById({uuid:this.messageData.uuid});
    // }, 100);
  }

  initMarkers(item: any) {

    // const initialMarkers = [
    //   {
    //     position: { lat: item?.location?.geo?.lat, lng: item?.location?.geo?.lon},
    //     draggable: false
    //   },

    // ];
    // for (let index = 0; index < initialMarkers.length; index++) {
    //   const data = initialMarkers[index];
    //   const marker = this.generateMarker(item,data, index);
    //   marker.on('mouseover', () => {
    //     marker.bindPopup(`<span style="color:blue"><b>${item?.name}\n</b></span><b>${item?.location?.baseCityName} | ${item?.location?.state} | ${item?.location?.countryName}</b>`).openPopup();
    //   });
    //   // marker.addTo(this.map).bindPopup(`<span style="color:blue"><b>${item?.name+"\n"}</span><b>${item?.location?.baseCityName} | ${item?.location?.state} | ${item?.location?.countryName}</b>`);
    //   marker.addTo(this.map)
    //   this.map.panTo(data?.position);
    //   this.markers.push(marker)





    // }
  }

  attachButtonHoverEvent(item: any) {
    setTimeout(() => {

      // console.log("ddd")
      // const button = document.getElementById('hoverButton'); // Get your button by ID
      // console.log(item)

      // console.log(this.markers)

      //     const markerData = this.markers.find((m:any) => m._latlng.lat=== item.location.geo.lat ); // Find the marker by its ID
      //     if (markerData) {
      //       const marker = markerData;
      //       marker.bindPopup(`<span style="color:blue"><b>${item?.name}\n</b></span><b>${item?.location?.baseCityName} | ${item?.location?.state} | ${item?.location?.countryName}</b>`).openPopup();
      //     }
      // const map = new google.maps.Map(document.getElementById('map'), {
      //   center: { lat: item.location.geo.lat, lng: item.location.geo.lon },
      //   zoom: 15
      // });


      const marker = new google.maps.Marker({
        position: { lat: item.location.geo.lat, lng: item.location.geo.lon },
        map: this.map
      });
      // console.log(item)
      // Create content for the popup
      const popupContent = `
  <span style="color:blue"><b>${item.name}</b></span><br>
  <b>${item.location.baseCityName} | ${item.location.state} | ${item.location.countryName}</b>
`;


      const infoWindow = new google.maps.InfoWindow({
        content: popupContent
      });

      marker.addListener('mouseover', () => {
        infoWindow.open(map, marker);
      });

      marker.addListener('mouseout', () => {
        infoWindow.close();
      });
      // const marker = new google.maps.Marker({
      //   position: { lat: item.location.geo.lat, lng: item.location.geo.lon },
      //   map: this.map
      // });

      // const popupContent = `
      //   <span style="color:blue"><b>${item.name}</b></span><br>
      //   <b>${item.location.baseCityName} | ${item.location.state} | ${item.location.countryName}</b>
      // `;

      // marker.addListener('mouseover', () => {
      //   const infoWindow = new google.maps.InfoWindow({
      //     content: popupContent
      //   });
      //   infoWindow.open(map, marker);
      // });

      // marker.addListener('mouseout', () => {
      //   const infoWindow = new google.maps.InfoWindow();
      //   infoWindow.close();
      // });


      var service = new google.maps.places.PlacesService(map);

      // Specify the location and radius for the search
      var request = {
        location: { lat: item.location.geo.lat, lng: item.location.geo.lon },
        radius: '500' // Adjust the radius as needed (in meters)
      };


      service.nearbySearch(request, function (results: any, status: any) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (var i = 0; i < results.length; i++) {
            var place = results[i];
            // Fetch detailed information about each place
            service.getDetails({ placeId: place.place_id }, function (placeDetails: any, status: any) {
              if (status === google.maps.places.PlacesServiceStatus.OK) {
                console.log('Place details:', placeDetails);
                // Here you can access reviews, ratings, and other details
                console.log('Reviews:', placeDetails.reviews);
                console.log('Rating:', placeDetails.rating);
                // Add more code to display these details on your map or page
              }
            });
          }
        }
      });



    }, 100)
  }

  generateMarker(item: any, data: any, index: number) {
    // if(item){
    //   HotelLef.Icon.Default.mergeOptions({
    //         iconRetinaUrl: 'assets/images/marker-icon-2x-green.png',
    //         iconUrl: 'assets/images/marker-icon-green.png',
    //         shadowUrl: 'assets/images/marker-shadow.png',

    //       });
    //       var customTextIcon = HotelLef.divIcon({
    //         className: 'custom-div-icon',
    //         html: '<div class="custom-marker-text" style="font-weight: bold;" >₹ '+(Number(item?.rooms[0]?.ratePlans[0]?.price?.basePrice)+Number(item?.rooms[0]?.ratePlans[0]?.price?.totalTax))+'</div>',

    //         iconSize: [100, 40],
    //         iconAnchor: [50, 20]
    //     });

    //     HotelLef.marker([item.location.geo.lat, item.location.geo.lon], { icon: customTextIcon }).addTo(this.map);

    // }
    ;
    // const map = new google.maps.Map(document.getElementById('map'), {
    //   center: { lat: item.location.geo.lat, lng: item.location.geo.lon },
    //   zoom: 15
    // });


    // Merge the custom icon options with the default options

    // console.log(charger);
    //   if(charger.chargerHealth.result.networkStatus==='Connected'){
    //     HotelLef.Icon.Default.mergeOptions({
    //     iconRetinaUrl: 'assets/images/marker-icon-2x-green.png',
    //     iconUrl: 'assets/images/marker-icon-green.png',
    //     shadowUrl: 'assets/images/marker-shadow.png'
    //   });
    // }
    //  else if(charger.chargerHealth.result.networkStatus!=='Connected'){
    //   HotelLef.Icon.Default.mergeOptions({
    //       iconRetinaUrl: 'assets/images/marker-icon-2x-red.png',
    //     iconUrl: 'assets/images/marker-icon-red.png',
    //     shadowUrl: 'assets/images/marker-shadow.png'
    //     });
    // }
    // return HotelLef.marker(data.position, { draggable: data.draggable })
    //   .on('click', (event) => this.markerClicked(event, index))
    //   .on('dragend', (event) => this.markerDragEnd(event, index));
  }
  markerClicked($event: any, index: number) {
    // console.log($event.latlng.lat, $event.latlng.lng);
  }

  markerDragEnd($event: any, index: number) {
    //console.log($event.target.getLatLng());
  }

  rateMapping(item: any) {
    let rating = Number(item)
    // console.log(item)
    if (rating) {
      if (rating < 3) {
        return "Average"
      } else if (rating >= 3 && rating <= 3.5) {
        return "Good"
      } else if (rating > 3.5 && rating < 4.2) {
        return "Very Good"

      } else if (rating >= 4.2) {
        return "Excellent"

      }
    }
    return ''
  }
  tooltipVisible: boolean = false

  findAmenities(item: any) {
    let amenities: any = []
    console.log()
    if (item && item.length > 0) {
      const desiredAmenities = ['Restaurant', 'Gym/ Fitness centre', 'Swimming Pool', 'Smoking rooms'];
      amenities = item.filter((ameni: any) => desiredAmenities.includes(ameni.displayName));
    }
    return amenities
  }

  meal: any
  rating: any
  source:any
  skeleton:boolean=false

  combineFilters() {
console.log('print_')
// this.skeleton=true
// console.log(this.skeleton)

    let filteredData = this.allData.filter((hotel: any) => {

      if (this.value) {
        if (hotel.rooms && hotel.rooms[0] && hotel.rooms[0].rate && hotel.rooms[0].rate.totalAmount > this.value) {
          return false;
        }
      }
      if (this.filterTime && this.filterTime.length > 0) {
        if (!this.filterTime.includes(hotel.starRating)) {

          return false
        }
      }

      if (this.rating && this.rating.length > 0) {
        console.log(this.rating)
        const ratingValue = parseFloat(hotel.reviewDetails.rating);

        if (!this.rating.includes(hotel.reviewDetails.rating) && !this.rating.some((r: any) => parseFloat(r) <= ratingValue)) {
          return false;
        }
      }

      if (this.meal && this.meal.length > 0) {
        if (!this.meal.includes(hotel.rooms[0]?.rate?.description)) {
          return false
        }
      }
      let SourceName:any=[]
      if(this.source){
      for(let soruce of this.source ){
        SourceName.push(soruce.split('(')[0])
      }
    }
      if (SourceName && SourceName.length > 0) {
        if (!SourceName.includes(hotel.source)) {
          return false
        }
      }
    

      if (this.hotel && this.hotel.length > 0) {
        if (!this.hotel.includes(hotel.name)) {
          return false
        }
      }
      

    if (this.pickUpLat && this.pickUpLong) {
      const maxDistance = 5; // Maximum distance in kilometers
      const toRadians = (degree: number) => (degree * Math.PI) / 180;
  
      const R = 6371; // Radius of the Earth in kilometers
      const lat1 = toRadians(this.pickUpLat);
      const lon1 = toRadians(this.pickUpLong);
      const lat2 = toRadians(hotel.geo.latitude);
      const lon2 = toRadians(hotel.geo.longitude);
  
      // Haversine formula
      const dLat = lat2 - lat1;
      const dLon = lon2 - lon1;
  
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1) * Math.cos(lat2) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
  
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in kilometers
  
      // Check if the hotel is within the max distance
      if (distance > maxDistance) {
        
        return false;
      }
    }
  
      return true;
    });




    this.hotelList = filteredData
    this.endIndex = 10;
    this.increment = 10;
    this.loadMoreHotels();


  }



  combineSelectFilters(event:any) {
    
        let filteredData = this.allData.filter((hotel: any) => {
    
          if (this.value) {
            if (hotel.rooms && hotel.rooms[0] && hotel.rooms[0].rate && hotel.rooms[0].rate.totalAmount > this.value) {
              return false;
            }
          }
          if (this.filterTime && this.filterTime.length > 0) {
            if (!this.filterTime.includes(hotel.starRating)) {
    
              return false
            }
          }
    
          if (this.rating && this.rating.length > 0) {
            console.log(this.rating)
            const ratingValue = parseFloat(hotel.reviewDetails.rating);
    
            if (!this.rating.includes(hotel.reviewDetails.rating) && !this.rating.some((r: any) => parseFloat(r) <= ratingValue)) {
              return false;
            }
          }
    
          if (this.meal && this.meal.length > 0) {
            if (!this.meal.includes(hotel.rooms[0]?.rate?.description)) {
              return false
            }
          }
          let SourceName:any=[]
          if(this.source){
          for(let soruce of this.source ){
            SourceName.push(soruce.split('(')[0])
          }
        }
          if (SourceName && SourceName.length > 0) {
            if (!SourceName.includes(hotel.source)) {
              return false
            }
          }

          
    
        
          
          // If user is typing a search query in the input field
          const inputValue = event?.target?.value?.toLowerCase()?.trim();
          if (inputValue && inputValue.length > 0) {

            if (inputValue?.trim()) {
              const query = inputValue.toLowerCase().trim();
              const hotelName = hotel.name?.toLowerCase().trim() || '';
            
              // First check startsWith, then includes
              if (!hotelName.startsWith(query) && !hotelName.includes(query)) {
                return false;
              }
            }
          }
          if(!inputValue){

          
          if (this.hotel && this.hotel.length > 0) {
            // Match either exact hotel name or partial match if typing too
            if (
              !this.hotel.some((h:any) =>
                h.toLowerCase().trim() === hotel.name.toLowerCase().trim()
              )
            ) {
              return false;
            }
          }
        }
          
    
        if (this.pickUpLat && this.pickUpLong) {
          const maxDistance = 5; // Maximum distance in kilometers
          const toRadians = (degree: number) => (degree * Math.PI) / 180;
      
          const R = 6371; // Radius of the Earth in kilometers
          const lat1 = toRadians(this.pickUpLat);
          const lon1 = toRadians(this.pickUpLong);
          const lat2 = toRadians(hotel.geo.latitude);
          const lon2 = toRadians(hotel.geo.longitude);
      
          // Haversine formula
          const dLat = lat2 - lat1;
          const dLon = lon2 - lon1;
      
          const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1) * Math.cos(lat2) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
      
          const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          const distance = R * c; // Distance in kilometers
      
          // Check if the hotel is within the max distance
          if (distance > maxDistance) {
            
            return false;
          }
        }
      
          return true;
        });
    
    
    
    
        this.hotelList = filteredData
        this.endIndex = 10;
        this.increment = 10;
        this.loadMoreHotels();
    
    
      }




  // ngAfterViewInit(): void {
  //   console.log('ngAfterViewInit triggered');
  //   if (typeof google === 'undefined') {
  //     const script = document.createElement('script');
  //     script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD4ZT_HzOrdyHl1cKO0eCc0bQsIBh4ROls &libraries=places';
  //     script.onload = () => {
  //       this.initializeMaps();
  //     };
  //     document.head.appendChild(script);
  //   } else {
  //     this.initializeMaps();
  //   }
  // }
  // initializeMaps(): void {
  //   const map = new google.maps.Map(document.getElementById('map'), {
  //     center: { lat: 12.9716, lng: 77.5946 },
  //     zoom: 15
  //   });
  // }
  onlyNumberKey(event: any) {

    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  showPanding: boolean = false
  nextData() {
    this.showPanding = true
    this.moreHotel()
  }
  center: google.maps.LatLngLiteral = { lat: 37.7749, lng: -122.4194 };
  zoom = 12;
  moreHotel() {
    let maps: any
    this.map = maps
    if (this.next != -1) {
      console.log(":)")
      let markers: L.Marker[] = [];
      this.markers = markers
      //  https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png
      //https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
      // https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}
      let mapKey = 'AIzaSyD4ZT_HzOrdyHl1cKO0eCc0bQsIBh4ROls'
      // https://maps.googleapis.com/maps/api/js?key='+mapKey+'&loading=async&libraries=maps,marker&v=beta
      // this.osm = HotelLef.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      // });
      // this.hotelList=null
      // this.allData=null

      // let markers:L.Marker[] = [];
      // this.markers=markers
      //  https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png
      //https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
      // https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}
      // let mapKey='AIzaSyD4ZT_HzOrdyHl1cKO0eCc0bQsIBh4ROls'
      // // https://maps.googleapis.com/maps/api/js?key='+mapKey+'&loading=async&libraries=maps,marker&v=beta
      //   this.osm = HotelLef.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.png', {
      //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      //   });
      // this.showDetails=false

      // this.showPending=true

      setTimeout(() => {
        this.showPending = false

      }, 20 * 60 * 1000);
      //  this.hotelList=null
      let request = JSON.parse(JSON.stringify(this.messageData))
      delete request.uuid;

      this.hotelService.SearchHotel(request)
        .subscribe({
          next: (res) => {

            // debounceTime(1), // Adjust the debounce time as needed
            // distinctUntilChanged(),

            if (res) {
              if (res[0].hotels.lenght != 0) {
                let data: any
                data = res
                this.showPending = false

                this.allData = data[0]?.hotels
                // for(let item of res[0]?.hotelDetailsList){
                // this.allData.push(item)
                // }
                this.next = res[0]?.next
                this.messageData.pageNo = Number(this.next)

                const uniqueNumbers = new Set<number>();
                let commonNumbers: number[] = [];

                //  if ( this.map) {
                //   this.map.remove();
                //   this.map = null;
                // }
                this.initializeMap()

                this.allData.forEach((item: any, index: number) => {

                  if (index === 0) {
                    this.map = new google.maps.Map(document.getElementById('map'), {
                      center: { lat: item.location.geo.lat, lng: item.location.geo.lon },
                      zoom: 15
                    });
                  }

                  const marker = new google.maps.Marker({
                    position: { lat: item.location.geo.lat, lng: item.location.geo.lon },
                    map: this.map
                  });
                  // console.log(item)
                  // Create content for the popup
                  const popupContent = `
              <span style="color:blue"><b>${item.name}</b></span><br>
              <b>${item.location.baseCityName} | ${item.location.state} | ${item.location.countryName}</b>
            `;

                  // Add an event listener for the mouseover event
                  marker.addListener('mouseover', () => {
                    const infoWindow = new google.maps.InfoWindow({
                      content: popupContent
                    });
                    infoWindow.open(map, marker);
                  });

                  // Optionally, add an event listener for mouseout to close the popup
                  marker.addListener('mouseout', () => {
                    const infoWindow = new google.maps.InfoWindow();
                    infoWindow.close();
                  });








                  // this.ngOnDestroy()
                  // setTimeout(() => {

                  // this.initMarkers(item);}, 100)
                  if (uniqueNumbers.has(item.starRating)) {
                    // If the number is already in the set, it's a common number
                    commonNumbers.push(item.starRating);
                  } else {
                    // Otherwise, add it to the set
                    uniqueNumbers.add(item.starRating);
                  }


                  this.starNumbers = new Set([...uniqueNumbers])
                  this.starNumbers = Array.from(this.starNumbers)
                  item.slideIndex = 1;

                  let slidImg: any = []

                  item.media.hotel[0].images.forEach((items: any) => {
                    let itm = { url: items };
                    if (itm.url && !(itm.url.startsWith("https://") || itm.url.startsWith("http://"))) {
                      itm.url = itm.url.replace('//', 'https://');
                    };
                    //if(itm.url) itm.url=itm.url.replace("http://","https://")
                    slidImg.push(itm);
                  });

                item.slides = slidImg

                // { img: '../../../assets/images/swimming-pool-beach-luxury-hotel-type-entertainment-complex-amara-dolce-vita-luxury-hotel-resort-tekirova-kemer-turkey.jpg', caption: 'Caption Two', id: 1 },




                //             item.slides = [
                //               { img: '../../../assets/images/swimming-pool-beach-luxury-hotel-type-entertainment-complex-amara-dolce-vita-luxury-hotel-resort-tekirova-kemer-turkey.jpg', caption: 'Caption Two', id: 1 },
                //   { img: '../../../assets/images/hotelroom2.avif', caption: 'Caption Text', id: 2 },
                //   {img: '../../../assets/images/frames-for-your-heart-zSG-kd-L6vw-unsplash.jpg', caption: 'Caption three', id: 3}

                // ];

                this.showSlides(item.slideIndex, item);

              })
      this.allData = this.allData.sort((a: any, b: any) => {
        const priceA = a.rooms[0]?.ratePlans.reduce((acc: any, curr: any) => acc + curr.price.basePrice, 0);
        const priceB = b.rooms[0]?.ratePlans.reduce((acc: any, curr: any) => acc + curr.price.basePrice, 0);
        return priceA - priceB;
      });
      this.hotelList = this.allData
      this.endIndex = 10;
      this.increment = 10;
      this.loadMoreHotels();


      // this.hotelList.sort((a:any, b:any) => {
      //   return  a.rooms[0]?.ratePlans[0]?.price?.basePrice
      // });

      this.calculateMinMaxPrices()

    }
    else {
      this.showPanding = false

      // this.toastMsgService.setMsg({msg : "Sorry, there are no matching results ",msgTitle:  "Warning", msgType : "W"});

    }

  }else{
  // this.router.navigate(["/app/flight"]);
  //  this.toastMsgService.setMsg({msg : "Sorry, there are no matching results ",msgTitle:  "Warning", msgType : "W"});
  this.showPanding = false


}
      }, error: (err) => {

  this.showPending = false

  //this.router.navigate(["/app/flight"]);
  this.toastMsgService.setMsg({ msg: "Sorry, there are no matching results ", msgTitle: "Warning", msgType: "W" });

}
    }
  )
}}

endIndex = 10;  // Start by showing the first 10 items
increment = 10;
private debounceTimer:any
visibleHotels: any[] = []; // List of hotels currently visible in the UI
onScroll(event: any) {
  // console.log('scroll event detected');

  const element = event.target;
  const scrollPosition = element.scrollTop + element.clientHeight;
  const scrollHeight = element.scrollHeight;
  const scrollPercentage = (scrollPosition / scrollHeight) * 100;
  // console.log(element.scrollHeight, element.scrollTop, element.clientHeight)
  if (scrollPercentage >= 80) {
    // If scrolled to the bottom, load more hotels

    // this.loadMoreHotels();
    this.debounceTimer = setTimeout(() => {
      this.loadMoreHotels()
    }, 200); // Delay by 200ms
    // this.loadMoreFlights();
  
  }
}
loadMoreHotels() {

  const nextIndex = Math.min(this.endIndex + this.increment, this.hotelList.length);
  this.visibleHotels = this.hotelList.slice(0, nextIndex);
  this.endIndex = nextIndex;
  // console.log(this.visibleHotels)


}
uniqueName = new Set<any>();
commonName: any[] = [];
commonMeals(item: any){

  if (this.uniqueName.has(item)) {
    // If the number is already in the set, it's a common number
    this.commonName.push(item);
  } else {
    // Otherwise, add it to the set
    this.uniqueName.add(item);
  }
  // console.log(this.uniqueName)
  let meals: any = new Set([...this.uniqueName])

  return meals

}




@Input() adressType: any;
@Output() setAddress: EventEmitter<any> = new EventEmitter();
@ViewChild('addresstextInput') addresstextInput: any;
addresstextValue: any = '';
autocompleteInput: any;
  pickUpLocation:any;
  dropOffLocation:any;
  location: any="kempegowda International Airport, Bengaluru, Karnataka, India.";
 
 
  lat:any;
  long:any;
  pickUpLat:any;
  pickUpLong:any;

  
  //   ngAfterViewInit() {
   
  //         setTimeout(() => {
  //           this.getPlaceAutocomplete();
  //         }, 5000);
      
  // }
  onChangeLocation(){
    // this.getPlaceAutocomplete();
          // this.getPlaceAutocomplete1();
  }

  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstextInput.nativeElement, {
      componentRestrictions: { country: 'IND' },
      types: [this.adressType]
    });

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  invokeEvent(place: any) {
    this.pickUpLocation = place.formatted_address as string; 
    this.pickUpLat=place.geometry.location.lat();
    this.pickUpLong=place.geometry.location.lng();
    console.log(this.pickUpLat);
    console.log(this.pickUpLong);
    this.combineFilters()
    this.setAddress.emit(place);

  }

  // private getPlaceAutocomplete1() {
  //   const autocomplete = new google.maps.places.Autocomplete(this.addresstextInput.nativeElement, {
  //     componentRestrictions: { country: 'IND' },
  //     types: [this.adressType]
  //   });

  //   const locationAutocomplete = new google.maps.places.Autocomplete(document.getElementById('locationInput'), {
  //     componentRestrictions: { country: 'IND' },
  //     types: [this.adressType]
  //   });

  //   google.maps.event.addListener(autocomplete, 'place_changed', () => {
  //     const place = autocomplete.getPlace();
  //     this.invokeEvent(place);
  //   });

  //   google.maps.event.addListener(locationAutocomplete, 'place_changed', () => {
  //     const locationPlace = locationAutocomplete.getPlace();
  //     this.onLocationChange(locationPlace);
  //   });
  // }

  // onLocationChange(place: any) {
  //   this.location = place.formatted_address as string;
  //   this.lat = place.geometry.location.lat();
  //   this.long = place.geometry.location.lng();
  //   console.log("Location:", this.location);
  //   console.log("Latitude:", this.lat);
  //   console.log("Longitude:", this.long);
  // }
 

  

}
